<template>
  <el-container>
    <el-header>
        <myHeader></myHeader>
    </el-header>
    <el-main>
      <div class="g-common-top-header">
        <!-- <div>
          <el-breadcrumb separator="|" style="padding-left: 5px; line-height: 35px;">
            <el-breadcrumb-item><a href="javascript:void(0)" style="font-weight:bold; color: blue" @click="toExamPaper">试卷设计</a></el-breadcrumb-item>
            <el-breadcrumb-item><a href="javascript:void(0)" style="font-weight:bold;">考试设置</a></el-breadcrumb-item>
          </el-breadcrumb>
        </div> -->
        <div class="g-tab-ctn">
          <div @click="switchTab(key, item)" v-for="(item, key) in constant.tabs" :class="item.class01" :key="key">
              <span :class="item.class02">{{ item.text }}</span>
          </div>
        </div>

        <div style="margin-left: auto;">
          <el-button type="primary" @click="submitForm()">保存</el-button>
          <el-button type="primary" @click="submitFormAndBack()">保存&返回列表</el-button>
          <el-button v-if="(!ksxx.zt || ksxx.zt == '0') && ksxx.ksyKssjList && ksxx.ksyKssjList.length > 0" type="success" @click="submitFormAndPublish()">保存&发布</el-button>
        </div>
      </div>

      <div class="g-common-ctn">
        <el-form ref="form" :model="ksxx" :inline="true" :rules="rules"
          label-position="right" label-width="110px" @submit.native.prevent size="small"
        >
          <!-- 基本信息 -->
          <!-- <el-row style="margin-bottom: 20px; width: 100%">
            <el-col style="background: #d3dce6; padding: 5px">基本信息</el-col>
          </el-row> -->

          <fieldset class="set-01">
            <legend class="legend-01">基本信息</legend>
            <el-form-item label="考试名称" class="formItem" prop="ksmc">
              <el-input v-model="ksxx.ksmc" style="width:400px" placeholder="请输入考试名称"></el-input>
            </el-form-item>
            <el-form-item label="考试分类" class="formItem" prop="flbh">
              <!-- <el-select ref="flbh" v-model="ksxx.flbh" style="width:400px;" placeholder="请选择考试分类" size="mini" @focus="reloadKsfl()">
                <el-option :value="flObj.flbh" :label="flObj.flmc" style="height: auto">
                  <classifyTree id="ksfltree" ref="ksfltree" :value.sync="flObj" type="exam" @click="$refs['flbh'].blur()"></classifyTree>
                </el-option>
              </el-select> -->
              <classify :value.sync="ksxx.flbh" type="exam" style="width:400px" :multiple="false"></classify>
              &nbsp;
              <el-button type="primary" @click="showFlDialog()">编辑考试分类</el-button>
            </el-form-item>
            <el-dialog title="编辑分类" :visible.sync="showKsflDialog" width="40%" center>
              <classifyTreeEdit ref="ksflTreeEdit" type="exam" :visible.sync="showKsflDialog"></classifyTreeEdit>
            </el-dialog>
            <br/>
            <el-form-item label="考试须知" class="formItem  flex-item" prop="ksxz">
              <el-input type="textarea" v-model="ksxx.ksxz" style="flex: 1;" placeholder="请输入考试须知"></el-input>
            </el-form-item>
          </fieldset>

          <!-- 考前设置 -->
          <fieldset class="set-01">
            <legend class="legend-01">考前设置</legend>
            <el-form-item label="考试开放时间" class="formItem" required>
              <el-form-item prop="ksyKscs.kfqssj" style="margin-bottom: 0;margin-right: 0;">
                  <el-date-picker
                      v-model="ksxx.ksyKscs.kfqssj"
                      type="datetime"
                      placeholder="选择日期时间"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      :picker-options="expireTimeOption">
                  </el-date-picker>
              </el-form-item>
              -
              <el-form-item prop="ksyKscs.kfjssj" style="margin-bottom: 0">
                  <el-date-picker
                      v-model="ksxx.ksyKscs.kfjssj"
                      type="datetime"
                      placeholder="选择日期时间"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      :picker-options="expireTimeOption">
                  </el-date-picker>
              </el-form-item>
            </el-form-item>
            <br/>
            <el-form-item label="答卷时间" class="formItem" prop="ksyKscs.djsj">
                <el-input v-model.number="ksxx.ksyKscs.djsj" autocomplete="off" style="width:80px" placeholder="请输入答卷时间"></el-input>&nbsp;分钟
            </el-form-item>
            <el-form-item label="最短交卷时间" class="formItem" prop="ksyKscs.zdjjsj" label-width="200px">
                <el-input v-model.number="ksxx.ksyKscs.zdjjsj" autocomplete="off" style="width:80px" placeholder="请输入最短交卷时间"></el-input>&nbsp;分钟
            </el-form-item>
            <br/>
            <el-form-item label="可考次数" class="formItem" required>
                <el-col style="width: 150px">
                    <el-form-item prop="ksyKscs.sfxzkscs" style="margin-bottom: 0">
                        <el-radio-group v-model="ksxx.ksyKscs.sfxzkscs">
                            <el-radio label="0">无限</el-radio>
                            <el-radio label="1">有限</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-col>
                <el-col style="width: 200px">
                    <el-form-item prop="ksyKscs.kkcs" style="margin-bottom: 0; margin-left: 10px" v-if="ksxx.ksyKscs.sfxzkscs === '1'">
                        <el-input-number style="width: 60px" v-model="ksxx.ksyKscs.kkcs" :precision="0" :controls="false" :min="1"/>&nbsp;次
                    </el-form-item>
                </el-col>
            </el-form-item>
            <br/>
            <el-form-item label="参考方式" class="formItem" prop="ksyKscs.ksckfs">
                <el-radio-group v-model="ksxx.ksyKscs.ksckfs" @change="changeCkfs">
                    <el-radio label="1">账号密码登录</el-radio>
                    <el-radio label="2">免登录考试</el-radio>
                    <!--
                    <el-radio label="3">微信免登录</el-radio>
                    -->
                </el-radio-group>
            </el-form-item>
            <div v-show="ksxx.ksyKscs.ksckfs === '1'">
                <!-- prop="ksyKscs_.cyks"  -->
                <el-form-item label="参与考生" class="formItem" :rules="[{ validator: validateCyks, trigger: 'change' }]">
                    <el-radio-group v-model="ksxx.ksyKscs_.cyks">
                        <el-radio label="0">全部参加</el-radio>
                        <el-radio label="1">指定部门</el-radio>
                        <el-radio label="2">指定考生</el-radio>
                    </el-radio-group>
                </el-form-item>
                <br/>
                <div v-show="ksxx.ksyKscs_.cyks === '1'">
                  <el-form-item label="选择部门" class="formItem">
                    <el-button type="primary" @click="showBmTree = true">部门列表</el-button>
                    <div style="display: inline-block; min-width: 100px; max-width: 800px; margin-right: 10px" id="deptNamesTag"></div>
                  </el-form-item>
                  <el-dialog title="选择部门" :visible.sync="showBmTree" width="30%" center>
                    <deptTree :value.sync="bmidList" :visible.sync="showBmTree"></deptTree>
                  </el-dialog>
                </div>
                <div v-show="ksxx.ksyKscs_.cyks === '2'">
                  <userTransfer style="padding: 0 50px 40px" :value.sync="yhidList" :desc="'考生'"></userTransfer>
                </div>
            </div>
            <div v-if="ksxx.ksyKscs.ksckfs === '2'">
                <el-form-item label="考生填写信息" class="formItem">
                    <!-- <table cellspacing="0" summary="考生需要填写的信息" cellpadding="0" style="display: inline-block; border:1px solid #0094ff;">
                      <tr style="background: #d3dce6;">
                        <th scope="col" style="text-align: left; padding-left: 10px;">考生信息</th>
                        <th scope="col" style="text-align: left; padding-left: 10px;">信息描述</th>
                        <th scope="col" style="padding: 0 10px">是否必填</th>
                        <th scope="col" style="padding: 0 20px">操作</th>
                      </tr>
                      <tr v-for="(ksyKsmdlsz, index) in ksxx.ksyKsmdlszList" :key="index" style="background: #f5f7fa;">
                        <td style="text-align: left;">
                          <el-form-item :prop="'ksyKsmdlszList.' + index + '.cjzdgs'" style="margin-bottom: 0;" :rules="[{ required: true, message: '采集字段格式不能为空', trigger: 'change'}]">
                            <el-select v-model="ksyKsmdlsz.cjzdgs" @change="(val) => changeCjzd(index, val)" style="width:120px;">
                              <el-option v-for="cjzd in cjzdList" :key="cjzd.dmz" :label="cjzd.dmms" :value="cjzd.dmz"></el-option>
                            </el-select>
                          </el-form-item>
                        </td>
                        <td style="text-align: left;">
                          <el-form-item :prop="'ksyKsmdlszList.' + index + '.cjzdmc'" style="margin-bottom: 0" :rules="[{ required: true, message: '采集字段名称不能为空', trigger: 'change'}]">
                            <el-input v-model="ksyKsmdlsz.cjzdmc" style="width:100px"></el-input>
                          </el-form-item>
                        </td>
                        <td style="text-align: center;">
                          <el-switch v-model="ksyKsmdlsz.sfbt" active-value="1" inactive-value="0"></el-switch>
                        </td>
                        <td style="text-align: center;">
                          <a href="javascript:void(0)" @click="removeKsyKsmdlsz(ksxx.ksyKsmdlszList, index)">删除</a>
                        </td>
                      </tr>
                    </table> -->

                    <div style="display:flex">
                      <el-table :data="ksxx.ksyKsmdlszList" border >
                      <!-- prop="date" -->
                        <el-table-column label="考生信息" width="160">
                          <template slot-scope="scope">
                            <div class="table-wrapper-01">
                              <el-form-item :prop="'ksyKsmdlszList.' + scope.$index + '.cjzdgs'" style="margin-bottom: 0;"
                                :rules="[{ required: true, message: '采集字段格式不能为空', trigger: 'change'}]">
                                <el-select v-model="scope.row.cjzdgs" @change="(val) => changeCjzd(scope.$index, val)" style="width:100%;">
                                  <el-option v-for="cjzd in cjzdList" :key="cjzd.dmz" :label="cjzd.dmms" :value="cjzd.dmz"></el-option>
                                </el-select>
                              </el-form-item>
                            </div>
                          </template>
                        </el-table-column>
                        <el-table-column  label="信息描述" width="170">
                          <template slot-scope="scope">
                            <div class="table-wrapper-01">
                              <el-form-item :prop="'ksyKsmdlszList.' + scope.$index + '.cjzdmc'" style="margin-bottom: 0" :rules="[{ required: true, message: '采集字段名称不能为空', trigger: 'change'}]">
                                <el-input v-model="scope.row.cjzdmc" style="width:100%;"></el-input>
                              </el-form-item>
                            </div>
                          </template>
                        </el-table-column>
                        <el-table-column  label="是否必填" width="70">
                          <template slot-scope="scope">
                            <el-switch v-model="scope.row.sfbt" active-value="1" inactive-value="0"></el-switch>
                          </template>
                        </el-table-column>
                        <el-table-column  label="操作" width="60">
                          <template slot-scope="scope">
                            <el-link type="danger" @click="removeKsyKsmdlsz(ksxx.ksyKsmdlszList, scope.$index)">删除</el-link>
                          </template>
                        </el-table-column>
                      </el-table>

                      <el-button type="primary" style="height:30px;margin-left: 7px; margin-top: 2px;"
                        @click="addKsyKsmdlsz(ksxx.ksyKsmdlszList)">添加</el-button>

                    </div>

                </el-form-item>
            </div>
            <div class="yjSet">
              <el-form-item label="阅卷模式" class="formItem" prop="ksyKscs.yjms">
                  <el-radio-group v-model="ksxx.ksyKscs.yjms">
                      <el-radio label="1">单评阅卷</el-radio>
                      <el-radio label="2">多评阅卷</el-radio>
                  </el-radio-group>
                  <div style="display: inline;" v-if="ksxx.ksyKscs.yjms === '2'">
                    设置整卷评分差值：<el-input-number style="width: 60px" v-model="ksxx.ksyKscs.zjpfcz" :precision="0" :controls="false" :min="0"/><span style="color: blue;">（当阅卷人超过2人时，评分差值超过此值，则需要第3个阅卷人介入仲裁）</span>
                  </div>
              </el-form-item>
              <br/>
              <el-form-item label="设置阅卷人" class="formItem" prop="ksyKscs_.yjrlx">
                  <el-radio-group v-model="ksxx.ksyKscs_.yjrlx">
                      <el-radio label="1">仅创建人</el-radio>
                      <el-radio label="2">指定员工</el-radio>
                  </el-radio-group>
              </el-form-item>
              <div v-show="ksxx.ksyKscs_.yjrlx === '2'">
                <userTransfer style="padding: 0 50px 20px" :value.sync="ksxx.ksyKscs_.yjrList" :desc="'员工'"></userTransfer>
                <el-divider class="divider01"></el-divider>
              </div>
              <template v-if="ksxx.ksyKscs.yjms === '2'">
                <br/>
                <el-form-item label="设置仲裁人" class="formItem" prop="ksyKscs_.zcrlx">
                    <el-radio-group v-model="ksxx.ksyKscs_.zcrlx">
                        <el-radio label="1">仅创建人</el-radio>
                        <el-radio label="2">指定员工</el-radio>
                    </el-radio-group>
                </el-form-item>
                <div v-show="ksxx.ksyKscs_.zcrlx === '2'">
                  <userTransfer style="padding: 0 50px 20px" :value.sync="ksxx.ksyKscs_.zcrList" :desc="'员工'"></userTransfer>
                  <el-divider class="divider01"></el-divider>
                </div>
              </template>
              <br/>
              <el-form-item label="设置复核人" class="formItem" prop="ksyKscs_.fhrlx">
                  <el-radio-group v-model="ksxx.ksyKscs_.fhrlx">
                      <el-radio label="1">仅创建人</el-radio>
                      <el-radio label="2">指定员工</el-radio>
                  </el-radio-group>
              </el-form-item>
              <div v-show="ksxx.ksyKscs_.fhrlx === '2'">
                <userTransfer style="padding: 0 50px 20px" :value.sync="ksxx.ksyKscs_.fhrList" :desc="'员工'"></userTransfer>
                <el-divider class="divider01"></el-divider>
              </div>
              <br/>
              <el-form-item label="是否显示考生信息" label-width="140px" class="formItem" prop="ksyKscs.sfxsksxx">
                  <el-radio-group v-model="ksxx.ksyKscs.sfxsksxx">
                      <el-radio label="1">显示</el-radio>
                      <el-radio label="0">不显示</el-radio>
                  </el-radio-group>
              </el-form-item>
            </div>
            <br/>
            <div class="txSet">
              <el-form-item label="提醒设置" class="formItem">
                <br/>
                <div>
                  <span>考试提醒设置</span>
                  <el-checkbox-group v-model="ksxx.ksyKscs_.kstxArr" @change="changeTxsz">
                    <el-checkbox v-for="kstx in kstxOptions" :label="kstx.dmz" :key="kstx.dmz">{{kstx.dmms}}</el-checkbox>
                  </el-checkbox-group>
                </div>
                <div>
                  <span>阅卷提醒设置</span>
                  <el-checkbox-group v-model="ksxx.ksyKscs_.yjtxArr" @change="changeTxsz">
                    <el-checkbox v-for="yjtx in yjtxOptions" :label="yjtx.dmz" :key="yjtx.dmz">{{yjtx.dmms}}</el-checkbox>
                  </el-checkbox-group>
                </div>
              </el-form-item>
            </div>
          </fieldset>
          <!-- 考中设置 -->

          <fieldset class="set-01">
            <legend class="legend-01">考中设置</legend>
            <el-form-item label="试题显示" class="formItem" prop="ksyKscs.stxs">
              <el-radio-group v-model="ksxx.ksyKscs.stxs">
                  <el-radio label="0" border>整卷模式：一页显示所有试题</el-radio>
                  <el-radio label="1" border>逐题模式：一页显示一道试题</el-radio>
              </el-radio-group>
            </el-form-item>
            <br/>
            <el-form-item label="防作弊设置" class="formItem">
              <el-checkbox v-model="ksxx.ksyKscs_.qp" true-label="1" false-label="0">
                只允许考试切换页面&nbsp;<el-input-number style="width: 50px" v-model="ksxx.ksyKscs.fzbYmqhcs" :precision="0" :controls="false" :min="0"/>&nbsp;次，
                否则强制交卷。其中：每次超过&nbsp;<el-input-number style="width: 60px" v-model="ksxx.ksyKscs.fzbQpsc" :precision="0" :controls="false" :min="0"/>&nbsp;秒，记切屏一次
              </el-checkbox>
              <br/>
              <el-checkbox v-model="ksxx.ksyKscs.fzbSfjzfzztjq" true-label="1" false-label="0">禁止考试复制、粘贴、剪切</el-checkbox>
              <!--
              <br/>
              <el-checkbox v-model="ksxx.ksyKscs.dtcs" true-label="1" false-label="0">
                答题超过<el-input-number style="width: 50px" v-model="ksxx.ksyKscs.fzbDtcs" :precision="0" :controls="false" :min="0"/>秒，没有新的操作会强制交卷
                <span style="color: blue">（建议有<span style="font-weight: bold">语音题</span>时<span style="font-weight: bold">不限制</span>时长）</span>
              </el-checkbox>
              -->
            </el-form-item>
            <br/>
            <el-form-item label="答题设置" class="formItem">
              <el-checkbox v-model="ksxx.ksyKscs.sfyxscfj" true-label="1" false-label="0">允许简答题上传附件</el-checkbox>
            </el-form-item>
          </fieldset>
          <!-- 考后设置 -->
          <fieldset class="set-01">
            <legend class="legend-01">考后设置</legend>
            <el-form-item label="及格分数" class="formItem" prop="ksyKscs.jgfs">
              <el-input style="width: 125px" v-model.number="ksxx.ksyKscs.jgfs" autocomplete="off" placeholder="请输入及格分数"></el-input>&nbsp;分
            </el-form-item>
            <br/>
            <el-form-item label="显示成绩" class="formItem">
                <el-switch v-model="ksxx.ksyKscs.sfxscj" @change="sfxscjChange" active-value="1" inactive-value="0"></el-switch>
            </el-form-item>
            <br/>
            <el-form-item label="" class="formItem" v-if="ksxx.ksyKscs.sfxscj === '1' " >
                <el-radio-group  v-model="sfxscjTemp"  style="margin: 0px 0px 10px 70px">
                    <el-radio  label="0">考后显示成绩</el-radio>
                    <el-radio  label="1">批改后显示成绩</el-radio>
                </el-radio-group>
            </el-form-item>
            <br/>
            <!-- <el-form-item label="允许查看试卷" class="formItem">
                <el-switch v-model="ksxx.ksyKscs.new01" @change="sfxscjChange" active-value="1" inactive-value="0"></el-switch>
            </el-form-item>
            <br/>
              <el-form-item label="" class="formItem" >
                  <el-radio-group v-model="ksxx.ksyKscs.new02" style="margin: 0px 0px 10px 70px">
                      <el-radio label="1">显示正确答案和解析</el-radio>
                      <el-radio label="0">不显示正确答案和解析</el-radio>
                  </el-radio-group>
              </el-form-item>
            <br/> -->
              <!-- <el-form-item label="" class="formItem" >
                  <el-radio-group v-model="ksxx.ksyKscs.new03" style="margin: 0px 0px 10px 70px">
                      <el-radio label="1">永久查看</el-radio>
                      <el-radio label="0">
                        <span style="padding-top: 5px">考试结束后 </span>
                          <el-input-number style="width:60px"  v-model="ksxx.ksyKscs.new04" :precision="0" :controls="false" />
                        <span style="padding-top: 5px"> 天可查看</span>
                      </el-radio>
                  </el-radio-group>
              </el-form-item>
            <br/> -->
            <span style="color: red; margin-left: 40px;">
              以下设置建议不要在有<span style="font-weight: bold">"简答题、录音题"</span>的时候启用，因为这些题型不能立刻出成绩
            </span>
            <hr style="margin-left: 10px; margin-right: 10px"/>
            <el-form-item label="显示击败比" class="formItem">
                <el-switch v-model="ksxx.ksyKscs.sfxsjbb" :disabled="ksxx.ksyKscs.sfxscj === '0'" active-value="1" inactive-value="0"></el-switch>
            </el-form-item>
            <br/>
            <el-form-item label="显示名次" class="formItem">
                <el-switch v-model="ksxx.ksyKscs.sfxsmc" :disabled="ksxx.ksyKscs.sfxscj === '0'" active-value="1" inactive-value="0"></el-switch>
            </el-form-item>
            <br/>
            <el-form-item label="显示排行榜" class="formItem" prop="ksyKscs.xsqjm">
                <el-switch v-model="ksxx.ksyKscs.sfxsphb" :disabled="ksxx.ksyKscs.sfxscj === '0'" active-value="1" inactive-value="0"></el-switch>
                <div style="display: inline-block; margin-left: 10px" v-if="ksxx.ksyKscs.sfxsphb === '1'">
                    前&nbsp;<el-input v-model.number="ksxx.ksyKscs.xsqjm" autocomplete="off" style="width:80px" ></el-input>&nbsp;名
                </div>
            </el-form-item>
            <br/>
            <el-form-item label="显示评语" class="formItem">
                <el-switch v-model="ksxx.ksyKscs.sfxspy" :disabled="ksxx.ksyKscs.sfxscj === '0'" active-value="1" inactive-value="0"></el-switch>
                <span v-show="ksxx.ksyKscs.sfxspy === '1'">
                  及格时：恭喜您，成功通过本次考试！
                  不及格时：很遗憾，您没有通过本次考试！
                </span>
            </el-form-item>
            <br/>
            <template v-if="ksxx.ksyKscs.sfxspy === '0'">
              <el-form-item label="考试结束语" class="formItem">
                  <el-input v-model="ksxx.ksyKscs.ksjsy" style="width:400px"></el-input>
              </el-form-item>
              <br/>
            </template>
            <el-form-item label="允许查看试卷" class="formItem">
                <el-switch v-model="ksxx.ksyKscs.sfyxcksj" active-value="1" inactive-value="0"></el-switch>
            </el-form-item>
            <br/>
            <el-form-item label="" class="formItem"  v-if="ksxx.ksyKscs.sfyxcksj === '1' " >
              <!-- sfyxcksjTemp 对应 sfyxcksj; sfyxcksjTemp 的值为1时则显示正确答案和解析 , sfyxcksjTemp 的值为2时则不显示正确答案和解析  -->
                <el-radio-group v-model="sfyxcksjTemp" style="margin: 0px 0px 10px 70px">
                    <el-radio label="0">显示分数、正确答案和解析</el-radio>
                    <el-radio label="1">不显示分数、正确答案和解析</el-radio>
                </el-radio-group>
            </el-form-item>
          </fieldset>
        </el-form>
      </div>
    </el-main>
  </el-container>
</template>
<script>
import myHeader from '@/components/myHeader'
import classify from '@/components/select/classify'
// import classifyTree from '@/components/tree/classifyTree'
import classifyTreeEdit from '@/components/tree/classifyTreeEdit'
import deptTree from '@/components/tree/deptTree'
import userTransfer from '@/components/transfer/userTransfer'
import { detail, save, publish } from '@/api/exam'
import { getDeptNames } from '@/api/user'
import { csbDmms } from '@/api/baseApi'
import constant from '../../assets/js/constant'
export default {
  data () {
    return {
      constant,
      flObj: {},
      sjid_init: null, // 默认的试卷ID
      ksid_init: null, // 默认的考试ID
      kstxOptions: [], // 考试提醒
      yjtxOptions: [], // 阅卷提醒
      cjzdList: [], // 采集字段
      bmidList: [], // 部门ID集合
      yhidList: [], // 用户ID集合
      showBmTree: false,
      showKsflDialog: false, // 显示考试分类
      sfxscjTemp: '0', // 考后显示成绩
      sfyxcksjTemp: '0', // 显示正确答案和解析
      ksxx: {
        ksyKscs_: {
          cyks: '2', // 参与考生
          qp: '0',
          kstxArr: [], // 考试提醒集合
          yjtxArr: [], // 阅卷提醒集合
          yjrlx: '1', // 阅卷人类型
          yjrList: [], // 阅卷人列表
          zcrlx: '1', // 多评类型
          zcrList: [], // 仲裁人列表
          fhrlx: '1', // 复核人类型
          fhrList: [] // 复核人列表
        },
        ksyKscs: {
          djsj: 60, // 答卷时间
          zdjjsj: 0, // 最短交卷时间
          ksckfs: '1', // 参考方式
          sfxzkscs: '1', // 是否限制考试次数
          kkcs: 1,
          // jgfs: 60, // 及格分数
          stxs: '0', // 试题显示
          ksjsy: '感谢您的作答！', // 感谢语
          sfxscj: '0', // 显示成绩
          sfxsjbb: '0', // 显示击败比
          sfxsmc: '0', // 显示名次
          sfxsphb: '0', // 显示排行榜
          xsqjm: 10, // 前10名
          sfxspy: '0', // 是否显示评语
          sfyxcksj: '0', // 允许查看试卷
          sfyxscfj: '1', // 是否允许简答题上传附件
          sfxsksxx: '1', // 是否显示考生信息
          yjms: '1', // 阅卷模式
          zjpfcz: null // 整卷评分差值
        },
        ksyKsmdlszList: [],
        ksyKszhmmszList: [],
        ksyKssjList: []
      },
      ksxxStr: JSON.stringify(this.ksxx),
      expireTimeOption: {
        disabledDate (time) {
          return time.getTime() <= (Date.now() - 8.64e7)
        }
      },
      rules: {
        ksmc: [
          { required: true, message: '请输入考试名称', trigger: 'blur' },
          { min: 1, max: 200, message: '长度在 1 到 200 个字符', trigger: 'blur' }
        ],
        flbh: [
          { required: true, message: '请选择分类编号', trigger: 'change' }
        ],
        'ksyKscs.kfqssj': [
          { required: true, message: '请选择考试开放起始时间', trigger: 'change' }
        ],
        'ksyKscs.kfjssj': [
          { required: true, message: '请选择考试开放结束时间', trigger: 'change' }
        ],
        'ksyKscs.djsj': [
          { required: true, message: '请输入答卷时间', trigger: 'change' },
          { type: 'number', message: '答卷时间必须为数字值' }
        ],
        'ksyKscs.zdjjsj': [
          { required: true, message: '请输入最短交卷时间', trigger: 'change' },
          { type: 'number', message: '最短交卷时间必须为数字值' }
        ],
        'ksyKscs.ksckfs': [
          { required: true, message: '请选择参考方式', trigger: 'change' }
        ],
        'ksyKscs.sfxzkscs': [
          { required: true, message: '请选择是否限制考试次数', trigger: 'change' }
        ],
        'ksyKscs.kkcs': [
          { required: true, message: '请选择可考次数', trigger: 'change' },
          { type: 'number', message: '可考次数必须为数字值' }
        ],
        'ksyKscs_.cyks': [
          { required: true, message: '请选择参与考生', trigger: 'change' }
        ],
        'ksyKscs.yjms': [
          { required: true, message: '请选择阅卷模式', trigger: 'change' }
        ],
        'ksyKscs_.zcrlx': [
          { required: true, message: '请设置仲裁人', trigger: 'change' }
        ],
        'ksyKscs_.yjrlx': [
          { required: true, message: '请设置阅卷人', trigger: 'change' }
        ],
        'ksyKscs_.fhrlx': [
          { required: true, message: '请设置复核人', trigger: 'change' }
        ],
        'ksyKscs.sfxsksxx': [
          { required: true, message: '请设置是否显示考生信息', trigger: 'change' }
        ],
        'ksyKscs.stxs': [
          { required: true, message: '请选择试题显示方式', trigger: 'change' }
        ],
        'ksyKscs.xsqjm': [
          { type: 'number', message: '排名必须为数字值' }
        ]
      }
    }
  },
  components: {
    myHeader,
    classify,
    // classifyTree,
    classifyTreeEdit,
    deptTree,
    userTransfer
  },
  watch: {
    flObj (val) {
      this.ksxx.flbh = val.flbh
    },
    'ksxx.ksyKscs_.kstxArr' (val, oldVal) {
      if (this.ksxx.ksyKscs_.cyks === '0' && val.length > 0 && oldVal.length === 0) {
        this.$message.warning('注意！当前为全部考生（包括高管）都会收到提醒')
      }
    },
    bmidList (val) {
      const bmids = val.join(',')
      this.appendDeptNamesTag(bmids)
    }
  },
  methods: {
    validateCyks (rule, value, callback) {
      if (this.ksxx.ksyKscs.ksckfs !== '2' && (value === null || value.length === 0)) {
        callback(new Error('请选择参与考生'))
      } else {
        callback()
      }
    },
    appendDeptNamesTag (bmids) {
      const params = { bmids: bmids }
      getDeptNames(params).then(res => {
        this.$http.callback(res, () => {
          document.getElementById('deptNamesTag').innerHTML = '&nbsp;<strong style="color: #356be9">（' + res.data + '）</strong>'
        })
      })
    },
    changeTxsz () {
      const kstxList = this.ksxx.ksyKscs_.kstxArr.map(kstx => {
        return { ksid: this.ksid, txdx: '1', txsz: kstx }
      })
      const yjtxList = this.ksxx.ksyKscs_.yjtxArr.map(yjtx => {
        return { ksid: this.ksid, txdx: '2', txsz: yjtx }
      })
      this.ksxx.txsz = kstxList.concat(yjtxList)
    },
    sfxscjChange (value) {
      if (value === '0') {
        this.ksxx.ksyKscs.sfxsjbb = '0'
        this.ksxx.ksyKscs.sfxsmc = '0'
        this.ksxx.ksyKscs.sfxsphb = '0'
        this.ksxx.ksyKscs.sfxspy = '0'
      }
    },
    removeKsyKsmdlsz (list, index) {
      if (list.length <= 1) {
        this.$message.warning('至少有一个采集字段')
        return
      }
      list.splice(index, 1)
    },
    switchTab (key, op) {
      if (op === 'init') {
        for (let i = 0; i < this.constant.tabs.length; i++) {
          if (key === i) {
            this.constant.tabs[i].class01 = 'g-tab-clicked'
            // this.constant.tabs[i].class02 = ''
          } else {
            this.constant.tabs[i].class01 = 'g-tab-unclicked'
            // this.constant.tabs[i].class02 = ''
          }
        }
        return
      }

      this.toExamPaper()
    },
    toExamPaper () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.ksxxStr !== JSON.stringify(this.ksxx)) {
            setTimeout(() => { // 此处必须要加延迟执行
              this.$confirm('是否放弃修改的内容？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
                this.toExamPaper2()
              }).catch(() => {})
            }, 200)
          } else {
            this.toExamPaper2()
          }
        } else {
          return false
        }
      })
    },
    toExamPaper2 () {
      if (this.ksxx.zt && this.ksxx.zt !== '0') {
        if (this.ksxx.zt === '2') {
          this.$message.warning('已完成的考试不能编辑试卷！')
        } else {
          this.$message.warning('考试已经开始了，不能对试卷进行编辑！')
        }
        return
      }
      const query = {
        ksid: this.ksxx.ksid
      }
      // 如果已绑定试卷，则进入试卷设计页面
      if (this.ksxx.ksyKssjList && this.ksxx.ksyKssjList.length > 0) {
        const sjids = this.ksxx.ksyKssjList.map(ksyKssj => ksyKssj.sjid).join(',')
        query.sjids = sjids
        this.$router.push({
          path: '/exam/edit',
          query: query
        })
      } else {
        this.$router.push({
          path: '/exam/add',
          query: query
        })
      }
    },
    changeCkfs (ksckfs) {
      if (ksckfs === '2') {
        if (this.ksxx.ksyKsmdlszList.length === 0) {
          this.addKsyKsmdlsz(this.ksxx.ksyKsmdlszList)
        }
      }
    },
    addKsyKsmdlsz (ksyKsmdlszList) {
      const maxId = ksyKsmdlszList.length > 0 ? Math.max.apply(null, ksyKsmdlszList.map(ksyKsmdlsz => Number(ksyKsmdlsz.cjzdid))) : 0
      const ksyKszhmmsz = {
        ksid: this.ksid,
        cjzdmc: '',
        cjzdid: maxId + 1,
        sfbt: '1'
      }
      ksyKsmdlszList.push(ksyKszhmmsz)
    },
    changeCjzd (index, dmz) {
      if (dmz !== null && dmz !== undefined) {
        const ksyKsmdlsz = this.ksxx.ksyKsmdlszList[index]
        if (ksyKsmdlsz.cjzdmc === '') {
          ksyKsmdlsz.cjzdmc = this.cjzdList.find(cjzd => cjzd.dmz === dmz).dmms
        }
      }
    },
    setParams () {
      if (this.ksxx.ksyKscs) {
        // 如果是账号密码登录
        if (this.ksxx.ksyKscs.ksckfs === '1') {
          // 如果是指定部门
          if (this.ksxx.ksyKscs_.cyks === '0') {
            this.ksxx.ksyKszhmmszList = [{ ksid: this.ksid, ckks: 0, zdfs: this.ksxx.ksyKscs_.cyks }]
          } else if (this.ksxx.ksyKscs_.cyks === '1') {
            this.ksxx.ksyKszhmmszList = this.bmidList.map(bmid => ({ ksid: this.ksid, ckks: bmid, zdfs: this.ksxx.ksyKscs_.cyks }))
          } else if (this.ksxx.ksyKscs_.cyks === '2') {
            this.ksxx.ksyKszhmmszList = this.yhidList.map(yhid => ({ ksid: this.ksid, ckks: yhid, zdfs: this.ksxx.ksyKscs_.cyks }))
          }
        }
        // 提醒设置
        const txsz1 = this.ksxx.ksyKscs_.kstxArr.map(a => {
          return { txdx: '1', txsz: a }
        })
        const txsz2 = this.ksxx.ksyKscs_.yjtxArr.map(a => {
          return { txdx: '2', txsz: a }
        })
        if (txsz1.length > 0 || txsz2.length > 0) {
          this.ksxx.ksyTxszList = txsz1.concat(txsz2)
        } else {
          this.ksxx.ksyTxszList = []
        }
        // 阅卷人
        if (this.ksxx.ksyKscs_.yjrlx === '1') {
          this.ksxx.ksyKsyjrszList = [{ yjrlx: '1' }]
        } else {
          this.ksxx.ksyKsyjrszList = this.ksxx.ksyKscs_.yjrList.map(a => {
            return { yjr: a, yjrlx: '2' }
          })
        }
        if (this.ksxx.ksyKscs.yjms === '2') {
          // 仲裁人
          if (this.ksxx.ksyKscs_.zcrlx === '1') {
            this.ksxx.ksyKszcrszList = [{ zcrlx: '1' }]
          } else {
            this.ksxx.ksyKszcrszList = this.ksxx.ksyKscs_.zcrList.map(a => {
              return { zcr: a, zcrlx: '2' }
            })
          }
        }
        // 复核人
        if (this.ksxx.ksyKscs_.fhrlx === '1') {
          this.ksxx.ksyKsfhrszList = [{ fhrlx: '1' }]
        } else {
          this.ksxx.ksyKsfhrszList = this.ksxx.ksyKscs_.fhrList.map(a => {
            return { fhr: a, fhrlx: '2' }
          })
        }
        // 切屏
        if (this.ksxx.ksyKscs_.qp === '0') {
          this.ksxx.ksyKscs.fzbYmqhcs = null
          this.ksxx.ksyKscs.fzbQpsc = null
        }
        // 答题超时
        if (this.ksxx.ksyKscs.dtcs === '0') {
          this.ksxx.ksyKscs.fzbDtcs = null
        }
      }
    },
    validateParams () {
      if (this.ksxx.ksyKscs.kfqssj >= this.ksxx.ksyKscs.kfjssj) {
        this.$message.warning('考试开放结束时间必须大于考试开放起始时间')
        return false
      }
      if (this.ksxx.ksyKscs.ksckfs === '2') {
        const cjzdgsList = this.ksxx.ksyKsmdlszList.map(o => o.cjzdgs)
        if ((new Set(cjzdgsList)).size !== cjzdgsList.length) {
          this.$message.warning('免登录考试时，不能填写重复的考生信息')
          return false
        }
      }
      if (this.ksxx.ksyKscs.yjms === '2' && this.ksxx.ksyKsyjrszList.length < 2) {
        this.$message.warning('多评模式下，至少要有2个阅卷人')
        return false
      }
      if (this.ksxx.ksyKscs.yjms === '2') {
        const yjrList = this.ksxx.ksyKscs_.yjrList
        const zcrList = this.ksxx.ksyKscs_.zcrList
        let all = [].concat(yjrList)
        all = all.concat(zcrList)
        all = [...new Set(all)]
        if (yjrList.length + zcrList.length !== all.length) {
          this.$message.warning('仲裁人不能跟阅卷人重复！')
          return false
        }
      }
      return true
    },
    submitForm (submitCallback, showMessage = true) {
      // 指定了仲裁人，但是仲裁人列表为空
      if (this.ksxx.ksyKscs_.zcrlx === '2') {
        if (this.ksxx.ksyKscs_.zcrList.length === 0) {
          this.$message.error('仲裁人指定员工不能为空！')
          return false
        }
      }

      if (this.ksxx.flbh === undefined) {
        this.$message.warning('请选择考试分类')
        return false
      }
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.setParams()
          if (!this.validateParams()) {
            return false
          }

          if (this.ksxx.ksyKscs.sfxscj !== '0') { // 为0时，则不显示成绩
            if (this.sfxscjTemp === '0') {
              this.ksxx.ksyKscs.sfxscj = '1' // 1:显示成绩,考后马上显示成绩
            } else {
              this.ksxx.ksyKscs.sfxscj = '2' // 2:显示成绩,阅卷后才显示成绩
            }
          }

          if (this.ksxx.ksyKscs.sfyxcksj !== '0') { // 为0时，则不允许查看试卷
            if (this.sfyxcksjTemp === '0') {
              this.ksxx.ksyKscs.sfyxcksj = '1' // 1:允许查看试卷,显示正确答案和解析
            } else {
              this.ksxx.ksyKscs.sfyxcksj = '2' // 2:允许查看试卷,不显示正确答案和解析
            }
          }
          console.log('提交前的sfxscj', this.ksxx.ksyKscs.sfxscj)
          console.log('提交前的sfyxcksj', this.ksxx.ksyKscs.sfyxcksj)
          const params = JSON.parse(JSON.stringify(this.ksxx))
          save(params).then(res => {
            console.log('异步请求后的sfxscj:', this.ksxx.ksyKscs.sfxscj)
            console.log('异步请求后的sfyxcksj:', this.ksxx.ksyKscs.sfyxcksj)
            this.$http.callback(res, () => {
              showMessage && this.$message.success(res.msg)
              this.ksxx.ksid = res.data
              this.ksid = res.data
              this.reverseOption(params) // 根据返回的 sfxscj, sfyxcksj 渲染 对应选项\
              // 生成快照
              setTimeout(() => {
                this.ksxxStr = JSON.stringify(this.ksxx)
              }, 200)
              // 修改浏览器地址
              const query = { ksid: this.ksxx.ksid }
              if (this.sjid_init) {
                query.sjid = this.sjid_init
              }
              this.$router.replace({
                path: '/exam/setting',
                query: query
              })
              this.getDetail(this.ksxx.ksid)
              submitCallback && submitCallback(res)
            })
          })
        } else {
          return false
        }
      })
    },
    submitFormAndPublish () {
      this.submitForm((res) => {
        const params = {
          ksid: res.data
        }
        publish(params).then(res => {
          this.$http.callback(res, () => {
            this.$message.success('保存并发布成功')
            this.ksxx.zt = '1'
          })
        })
      }, false)
    },
    submitFormAndBack () {
      this.submitForm((res) => {
        this.$message.success(res.msg)
        setTimeout(() => {
          this.$router.push({
            path: '/exam/list'
          })
        }, 100)
      }, false)
    },
    initKsyKscs_ () {
      this.$set(this.ksxx, 'ksyKscs_', {})
      this.$set(this.ksxx.ksyKscs_, 'cyks', null)
      this.$set(this.ksxx.ksyKscs_, 'qp', '0')
      this.$set(this.ksxx.ksyKscs_, 'kstxArr', [])
      this.$set(this.ksxx.ksyKscs_, 'yjtxArr', [])
      this.$set(this.ksxx.ksyKscs_, 'zcrlx', null)
      this.$set(this.ksxx.ksyKscs_, 'zcrList', [])
      this.$set(this.ksxx.ksyKscs_, 'yjrlx', null)
      this.$set(this.ksxx.ksyKscs_, 'yjrList', [])
      this.$set(this.ksxx.ksyKscs_, 'fhrlx', null)
      this.$set(this.ksxx.ksyKscs_, 'fhrList', [])
    },
    reverseOption (ksxx) {
      // 根据返回的 sfxscj, sfyxcksj 渲染 对应选项
      if (ksxx.ksyKscs.sfxscj === '1') {
        this.ksxx.ksyKscs.sfxscj = '1'
        this.sfxscjTemp = '0'
      } else if (ksxx.ksyKscs.sfxscj === '2') {
        this.ksxx.ksyKscs.sfxscj = '1'
        this.sfxscjTemp = '1'
      } else {
        this.ksxx.ksyKscs.sfxscj = '0'
        this.sfxscjTemp = '0'
      }
      if (ksxx.ksyKscs.sfyxcksj === '1') {
        this.ksxx.ksyKscs.sfyxcksj = '1'
        this.sfyxcksjTemp = '0'
      } else if (ksxx.ksyKscs.sfyxcksj === '2') {
        this.ksxx.ksyKscs.sfyxcksj = '1'
        this.sfyxcksjTemp = '1'
      } else {
        this.ksxx.ksyKscs.sfyxcksj = '0'
        this.sfyxcksjTemp = '0'
      }
    },
    transformOption (resData) {
      // 根据返回的 sfxscj, sfyxcksj 渲染 对应选项
      if (resData.ksyKscs.sfxscj === '1') {
        resData.ksyKscs.sfxscj = '1'
        this.sfxscjTemp = '0'
      } else if (resData.ksyKscs.sfxscj === '2') {
        resData.ksyKscs.sfxscj = '1'
        this.sfxscjTemp = '1'
      } else {
        resData.ksyKscs.sfxscj = '0'
        this.sfxscjTemp = '0'
      }

      if (resData.ksyKscs.sfyxcksj === '1') {
        resData.ksyKscs.sfyxcksj = '1'
        this.sfyxcksjTemp = '0'
      } else if (resData.ksyKscs.sfyxcksj === '2') {
        resData.ksyKscs.sfyxcksj = '1'
        this.sfyxcksjTemp = '1'
      } else {
        resData.ksyKscs.sfyxcksj = '0'
        this.sfyxcksjTemp = '0'
      }
      return resData
    },
    getDetail (ksid) {
      const params = { ksid: ksid }
      detail(params).then(res => {
        this.$http.callback(res, () => {
          if (res.data) {
            this.ksxx = this.transformOption(res.data)
            this.initKsyKscs_()
            this.flObj = { flbh: this.ksxx.flbh, flmc: this.ksxx.flmc }
            this.ksid = this.ksxx.ksid
            if (this.ksxx.ksyKszhmmszList && this.ksxx.ksyKszhmmszList.length > 0) {
              const cyks = this.ksxx.ksyKszhmmszList[0].zdfs
              this.ksxx.ksyKscs_.cyks = cyks
              // 如果是指定部门
              if (cyks === '1') {
                this.bmidList = this.ksxx.ksyKszhmmszList.map(ksyKszhmmsz => ksyKszhmmsz.ckks)
              }
              // 如果是指定用户
              if (cyks === '2') {
                this.yhidList = this.ksxx.ksyKszhmmszList.map(ksyKszhmmsz => ksyKszhmmsz.ckks)
              }
            }
            // 切屏
            if (this.ksxx.ksyKscs.fzbYmqhcs != null && this.ksxx.ksyKscs.fzbQpsc != null) {
              this.ksxx.ksyKscs_.qp = '1'
            }
            if (this.ksxx.ksyTxszList && this.ksxx.ksyTxszList.length > 0) {
              this.ksxx.ksyKscs_.kstxArr = this.ksxx.ksyTxszList.filter(a => a.txdx === '1').map(a => a.txsz)
              this.ksxx.ksyKscs_.yjtxArr = this.ksxx.ksyTxszList.filter(a => a.txdx === '2').map(a => a.txsz)
            }
            // 仲裁人
            if (this.ksxx.ksyKszcrszList && this.ksxx.ksyKszcrszList.length > 0) {
              const cjrList = this.ksxx.ksyKszcrszList.filter(a => a.zcrlx === '1').map(a => a.zrc)
              const zcrList = this.ksxx.ksyKszcrszList.filter(a => a.zcrlx === '2').map(a => a.zcr)
              if (cjrList && cjrList.length > 0) {
                this.ksxx.ksyKscs_.zcrlx = '1'
              }
              if (zcrList && zcrList.length > 0) {
                this.ksxx.ksyKscs_.zcrlx = '2'
                this.ksxx.ksyKscs_.zcrList = zcrList
              }
            }
            if (this.ksxx.ksyKsyjrszList && this.ksxx.ksyKsyjrszList.length > 0) {
              const cjrList = this.ksxx.ksyKsyjrszList.filter(a => a.yjrlx === '1').map(a => a.yjr)
              const yjrList = this.ksxx.ksyKsyjrszList.filter(a => a.yjrlx === '2').map(a => a.yjr)
              if (cjrList && cjrList.length > 0) {
                this.ksxx.ksyKscs_.yjrlx = '1'
              }
              if (yjrList && yjrList.length > 0) {
                this.ksxx.ksyKscs_.yjrlx = '2'
                this.ksxx.ksyKscs_.yjrList = yjrList
              }
            }
            if (this.ksxx.ksyKsfhrszList && this.ksxx.ksyKsfhrszList.length > 0) {
              const cjrList = this.ksxx.ksyKsfhrszList.filter(a => a.fhrlx === '1').map(a => a.fhr)
              const fhrList = this.ksxx.ksyKsfhrszList.filter(a => a.fhrlx === '2').map(a => a.fhr)
              if (cjrList && cjrList.length > 0) {
                this.ksxx.ksyKscs_.fhrlx = '1'
              }
              if (fhrList && fhrList.length > 0) {
                this.ksxx.ksyKscs_.fhrlx = '2'
                this.ksxx.ksyKscs_.fhrList = fhrList
              }
            }
          }
          // 生成快照
          setTimeout(() => {
            this.ksxxStr = JSON.stringify(this.ksxx)
          }, 200)
        })
      })
    },
    showFlDialog () {
      this.showKsflDialog = true
      if (this.$refs.ksflTreeEdit !== undefined) {
        this.$refs.ksflTreeEdit.init()
      }
    },
    reloadKsfl () {
      setTimeout(() => {
        this.$refs.ksfltree.init()
      }, 200)
    }
  },
  created () {
    this.sjid_init = this.$route.query.sjid
    this.ksid_init = this.$route.query.ksid
    // 如果有ksid传入进来 则加载考试信息
    if (this.ksid_init) {
      this.getDetail(this.ksid_init)
    } else {
      // 如果是新建考试，判断是否有试卷ID 有则添加到考试中
      if (this.sjid_init) {
        if (!this.ksxx.ksyKssjList) {
          this.ksxx.ksyKssjList = []
        }
        this.ksxx.ksyKssjList.push({ sjid: this.sjid_init })
      }
    }
    // 加载采集字段列表
    csbDmms({ dmmc: 'KSCJZDGS' }).then(res => {
      this.$http.callback(res, () => {
        this.cjzdList = res.data
      })
    })
    // 加载考试提醒选项
    csbDmms({ dmmc: 'KSTX' }).then(res => {
      this.$http.callback(res, () => {
        this.kstxOptions = res.data
      })
    })
    // 加载阅卷提醒选项
    csbDmms({ dmmc: 'YJTX' }).then(res => {
      this.$http.callback(res, () => {
        this.yjtxOptions = res.data
      })
    })

    this.switchTab(1, 'init')
  },
  beforeUpdate () {
    console.log('beforeUpdate---sfxscj:', this.ksxx.ksyKscs.sfxscj)
    console.log('beforeUpdate---sfyxcksj:', this.ksxx.ksyKscs.sfyxcksj)
  }
}
</script>
<style lang="less" scoped>

  .set-01{
    border: 1px solid #ccc;
    border-radius: 4px;
    margin-bottom: 20px;

    &:last-child{
      margin-bottom:0;
    }
  }

  .formItem{
    margin-left: 10px
  }
  .yjSet {
    // background-color: #fff;
    // box-shadow: ;
    box-shadow: 0 3px 10px 0 rgba(0, 0, 0, .08);
    border-radius: 3px;
    padding: 15px;
    margin: 0 10px;
    // border: 1px solid #ccc;
    .formItem {
      margin: 0;
    }
  }

  .txSet{
    box-shadow: 0 3px 10px 0 rgba(0, 0, 0, .08);
    border-radius: 3px;
    padding: 10px 0;
    margin: 0 10px;

    .formItem {
      margin: 0;
    }
  }

  #ksfltree /deep/ * {
    font-weight: normal !important;
  }

  .table-wrapper-01{
    /deep/ .el-form-item{
      margin-right: 0px;
    }
  }

  .divider01{
    margin: 15px 0;
  }
  .flex-item{
    display: flex;
    width: calc(100% - 30px);
     /deep/ .el-form-item__content{
      flex: 1;
    }
  }
</style>
